import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getPaymentMethodsFromSupplierRequest,
  transactionPaymentCreateRequest,
} from "../redux/paymentActions";
import { getPaymentCreationState } from "../redux/paymentSelectors";
import { getPaymentById } from "../../../Redux/Selectors/paymentSelector";
import { getSupplierData } from "../../../Redux/Selectors/appConfigSelector";
import { PAYMENT_METHOD_LABELS } from "../PaymentMethods";
import BasePaymentMethodScreen from "../components/BasePaymentMethodScreen";

const WireTransferPaymentMethodScreen = ({
  transactionId,
  transactionCustomId,
  amount,
  currency,
  onReady,
  summary,
  paymentInformation,
}) => {
  const dispatch = useDispatch();
  const {
    paymentId,
    loading: paymentCreationLoading,
    error: paymentCreationError,
    success: paymentCreationSuccess,
  } = useSelector(getPaymentCreationState, shallowEqual);
  const supplierData = useSelector(getSupplierData, shallowEqual);
  const payment = useSelector((state) => getPaymentById(state, paymentId));

  useEffect(() => {
    dispatch(
      transactionPaymentCreateRequest({
        provider: PAYMENT_METHOD_LABELS.wireTransfer,
        amount,
        currency,
        transactionId,
      })
    );
    dispatch(getPaymentMethodsFromSupplierRequest(supplierData._id));
  }, []);

  useEffect(() => {
    if (
      !payment ||
      paymentCreationLoading ||
      (!paymentCreationSuccess && !paymentCreationError)
    ) {
      return;
    }
    onReady();
  }, [payment, paymentCreationSuccess, paymentCreationError]);

  return (
    <BasePaymentMethodScreen
      transactionCustomId={transactionCustomId}
      summary={summary}
      paymentInformation={paymentInformation}
      supplierData={supplierData}
      descriptionTitle="wireTransferPayment"
    />
  );
};

WireTransferPaymentMethodScreen.propTypes = {
  transactionId: PropTypes.string.isRequired,
  transactionCustomId: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  onReady: PropTypes.func.isRequired,
  summary: PropTypes.object,
  paymentInformation: PropTypes.object.isRequired,
};

export default WireTransferPaymentMethodScreen;
